export const CURRENT_LEAGUE = "keepers"
export const CURRENT_HARDCORE_LEAGUE = "hardcore keepers"
export const EVENT_LEAGUE = "phrecia"
export const HARDCORE_EVENT_LEAGUE = "hardcore phrecia"
